!(function (win, doc, $) {
  $.fn.AddClassWhenVisible = function (options){
    const $this = this;
    const settings = {
      class: '',
      removeClassWhenHidden: false,
      replaceClass: '',
      viewOffset: 40
    };
    let scrollY = win.pageYOffset;
    const viewportHeight = Math.max(doc.documentElement.clientHeight, win.innerHeight || 0);
    let ready = false;
    $.extend(settings, options);

    win.addEventListener('scroll', function () {
      scrollY = win.pageYOffset;
      requestAnimationFrameWhenReady();
    }, false);

    function requestAnimationFrameWhenReady() {
      if (!ready) {
        requestAnimationFrame(animate);
        ready = true;
      }
    }
    function animate() {
      const elemTop = $this.offset().top;
      if (!settings.removeClassWhenHidden) {
        if (scrollY + settings.viewOffset < elemTop && scrollY + viewportHeight + settings.viewOffset > elemTop) {
          if (!$this.hasClass(settings.class)) {
            $this.addClass(settings.class);
            if (settings.replaceClass !== '') {
              $this.removeClass(settings.replaceClass);
            }
          }
        }
      } else {
        const elemHeight = $this.height();
        const elemBot = elemTop + elemHeight;
        const viewportBot = (scrollY + viewportHeight) - settings.viewOffset;
        if (elemTop < viewportBot && elemBot > scrollY) {
          if (!$this.hasClass(settings.class)) {
            $this.addClass(settings.class);
            if (settings.replaceClass !== '') {
              $this.removeClass(settings.replaceClass);
            }
          }
        } else if ($this.hasClass(settings.class)) {
          $this.removeClass(settings.class);
          if (settings.replaceClass !== '') {
            $this.addClass(settings.replaceClass);
          }
        }
      }

      ready = false;
    }
    return this;
  };
}(window, document, window.jQuery));
